import { useSelector } from "react-redux";
import { getPageError } from "../../api/features/nav/load-status/selectors";

export default function usePageError() {
  return useSelector(getPageError);
}
